import React from 'react';
import { createRoot } from "react-dom/client";
// Import theme CSS first to ensure it loads before default styles
import './theme/variables-global-e.scss';
import './index.css';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import startup from './services/startup-service';
import DashboardTranslationScope from './dashboard-translation/dashboard-translation-locale';


startup().then(() => {
    const container = document.getElementById("root");
    const root = createRoot(container!);
    root.render(
    	<React.StrictMode>
            <DashboardTranslationScope>
                {/*
                  The ErrorBoundary component wraps the entire application below.
                  This is a global React error boundary powered by Sentry.
                  It will catch any uncaught JavaScript errors in the component tree,
                  report them to Sentry, and display a user-friendly fallback UI instead of a blank screen.
                  This is a significant change: previously, such errors would crash the app silently or show nothing.
                  This improves error visibility and robustness, but reviewers should note the new fallback UI for uncaught errors.
                  If you have questions or concerns about this change, please see the implementation in src/components/ErrorBoundary.tsx or discuss further.
                */}
                <ErrorBoundary>
                    <App />
                </ErrorBoundary>
            </DashboardTranslationScope>
    	</React.StrictMode>
    );
});
